import { render, staticRenderFns } from "./employee.vue?vue&type=template&id=54bb76a9&scoped=true&"
import script from "./employee.vue?vue&type=script&lang=js&"
export * from "./employee.vue?vue&type=script&lang=js&"
import style0 from "./employee.vue?vue&type=style&index=0&id=54bb76a9&lang=scss&scoped=true&"
import style1 from "./employee.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bb76a9",
  null
  
)

export default component.exports